import * as React from 'react';
import { SetStateAction, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Checkbox, FormControl, FormControlLabel, Grid, LinearProgress, Typography, Paper, IconButton, Button, FormHelperText } from '@mui/material';
import useAuth from "../../context/AuthProvider";
import { InsuranceCompanyModel, InsuranceCompanyModel_VS } from '../../models/insuranceCompanyModel';
import { Form, Formik } from 'formik';
import { FMSelectActiveInactive } from '../Elements/select';
import { stateOptions } from './AddEditPartners';
import { lineOfBusinessModel } from '../Lists/CarrierManagementList';
import Swal from 'sweetalert2';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FMTextField } from '../Elements/input';
import { apiClient } from '../../helper/api';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

const textFieldSx = {
  '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px !important' },
  '& .MuiInputBase-input': { padding: '5px 14px !important' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};

interface Iprops {
    InsuranceCompanyCL: InsuranceCompanyModel,
    handleClose: () => void,
    Open: boolean,
    handleSubmit: () => void,
    initValues: InsuranceCompanyModel
    selectedStates: stateOptions[]
    States: stateOptions[],
    setselectedStates: React.Dispatch<SetStateAction<stateOptions[]>>,
    setStates: React.Dispatch<SetStateAction<stateOptions[]>>,
    handleCheckBoxChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    selectedLineOfBusiness: lineOfBusinessModel[],
    LineOfBusiness: lineOfBusinessModel[]
    handleLineOfBusinessCheckBoxChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    //handleStartDate: (event: React.ChangeEvent<HTMLInputElement>) => void,
    selectAll: () => void,
    handleStateEdit: (id: number) => void
    setselectedLineOfBusiness: React.Dispatch<React.SetStateAction<lineOfBusinessModel[]>>
}
interface IStateCheckBoxprops {
    selectedStates: stateOptions[],
    States: stateOptions[],
    handleCheckBoxChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    handleStateEdit: (id: number) => void
}

interface CustomFormData {
    InsuranceCompanyData: InsuranceCompanyModel,
    selectedStates: string,
    selectedLineOfBusiness: string,
    states: stateOptions[],
    lineOfBusiness: lineOfBusinessModel[]
    //selectedDates:Date,
}

const StateCheckBoxCustom: React.FC<IStateCheckBoxprops> = ({ selectedStates, States, handleCheckBoxChange, handleStateEdit }) => {
    return (
        <Grid container spacing={2} sx={{ pl: 2, pt: 3 }}>
            {States?.map((item, key) => {
                const isChecked = selectedStates?.length > 0 && selectedStates?.some(element => element.stateId === item.stateId);
                return (
                // <Grid item key={key} xs={12} sm={6} md={4} sx={{ mt: 1, mb: 1 }}>
                    <FormControlLabel
                        sx={{ pointerEvents: 'none', '& .MuiCheckbox-root': { color: '#2099d2' } }}
                        control={
                            <Checkbox
                                sx={{ pointerEvents: 'auto', color: '#2099d2' }}
                                name={item.stateId.toString()}
                                onChange={handleCheckBoxChange}
                                checked={!!isChecked}
                            />
                        }
                            label={
                                <div className="d-flex gap-2">
                                    <div >
                                        {item.stateName}
                                    </div>
                                    <div>
                                        {isChecked ? (
                                            <Button
                                                className=" btn action-btn"
                                                onClick={() => handleStateEdit(item.stateId)}
                                                title="Edit"
                                            >
                                                <i className="fa fa-edit text-primary" style={{ pointerEvents: "auto" }} ></i>
                                            </Button>

                                        ) : (
                                            <i></i>
                                        )}
                                    </div>
                                </div>
                            }
                        />
                // </Grid>
                );
            })}
        </Grid>
    );
}


export const AddEditCarriermanagement: React.FC<Iprops> = ({ selectAll, handleClose, Open, handleStateEdit, InsuranceCompanyCL, handleSubmit, initValues, selectedStates, States, setselectedStates, setselectedLineOfBusiness, setStates, handleCheckBoxChange, selectedLineOfBusiness, LineOfBusiness, handleLineOfBusinessCheckBoxChange }) => {

    const initialValues: InsuranceCompanyModel = initValues ? InsuranceCompanyCL : initValues;
    const { user } = useAuth();
    const token = user?.token;

    let initFomvalues: CustomFormData = {
        InsuranceCompanyData: initialValues,
        selectedStates: '',
        selectedLineOfBusiness: '',
        states: [],
        lineOfBusiness: []
    }


    const [loading, setloading] = useState(false);

    return (
        <Dialog
            open={Open}
            onClose={handleClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    width: '90%',
                    maxWidth: 900,
                    minHeight: '70vh',
                    maxHeight: '90vh',
                    borderRadius: 2,
                    boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
                },
            }}
            sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
        >
            {loading && <LinearProgress sx={{ flexShrink: 0 }} />}
            <DialogTitle
                sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    py: 2,
                    px: 3,
                    background: 'linear-gradient(135deg, #0d4a63 0%, #15607a 100%)',
                    color: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <BusinessCenterOutlinedIcon sx={{ fontSize: 28, opacity: 0.95 }} />
                    <Typography component="span" variant="h6" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
                        Carrier Management
                    </Typography>
                </Box>
                <IconButton
                    onClick={handleClose}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' } }}
                    aria-label="Close dialog"
                >
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Formik initialValues={initFomvalues}
                    validateOnChange={true}
                    validationSchema={InsuranceCompanyModel_VS}
                    onSubmit={(data, { setSubmitting }) => {
                        setloading(true);
                        data.lineOfBusiness = selectedLineOfBusiness;
                        data.states = selectedStates;
                        data.InsuranceCompanyData.startDate = data.InsuranceCompanyData.startDate ?? '';
                        if (data.states.length === 0) {
                            Swal.fire({
                                title: 'Warning',
                                text: "Please select a state",
                                icon: 'warning',
                                confirmButtonColor: '#3085d6',
                            })
                                .then((result) => {
                                    setloading(false);
                                    setSubmitting(false);
                                    return;
                                })
                        }
                        else {
                            apiClient('/InsuranceCompany/put',
                                {
                                    method: 'POST',
                                    headers: new Headers({
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${token}`,
                                    }),
                                    body: JSON.stringify(data)  // <-- Post parameters

                                })
                                .then((response) => {
                                    setloading(false);

                                    if (!response) return
                                    Swal.fire({
                                        title: "Data Successfully saved",
                                        text: "",
                                        icon: "success",
                                        confirmButtonText: "OK",
                                    });
                                    handleClose();
                                    setselectedLineOfBusiness([]);
                                    // Do something with the response
                                    handleSubmit()
                                    
                                }).finally(() => {
                                    setloading(false);
                                    setSubmitting(true)
                                });
                        }

                    }} >
                    {({ values, isSubmitting, setFieldValue, touched, errors }) => (

                        <Form className="main-form">
                            <DialogContent sx={{ width: '100%', minHeight: '50vh', overflow: 'auto', px: { xs: 2, sm: 3 }, py: 3 }}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 }}>
                                            Carrier details
                                        </Typography>
                                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50' }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth>
                                                        <FormHelperText className="formtexthelper-heading">Carrier</FormHelperText>
                                                        <FMTextField name="InsuranceCompanyData.name" autoFocus margin="dense" label={null} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth>
                                                        <FormHelperText className="formtexthelper-heading">NAIC Number</FormHelperText>
                                                        <FMTextField name="InsuranceCompanyData.naicNumber" margin="dense" label={null} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth>
                                                        <FormHelperText className="formtexthelper-heading">Start Date</FormHelperText>
                                                        <FMTextField name="InsuranceCompanyData.startDate" margin="dense" label={null} type="date" InputLabelProps={{ shrink: true }} fullWidth variant="outlined" sx={textFieldSx} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth>
                                                        <FMSelectActiveInactive name="InsuranceCompanyData.isActive" />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 }}>
                                            States
                                        </Typography>
                                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50', maxHeight: 500, overflow: 'auto' }}>
                                            <Button variant="contained" size="small" onClick={selectAll} type="button" sx={{ mb: 2, textTransform: 'none', fontWeight: 600, backgroundColor: '#2099d2', '&:hover': { backgroundColor: '#176990' } }}>
                                                Select All States
                                            </Button>
                                            <StateCheckBoxCustom selectedStates={selectedStates} States={States} handleCheckBoxChange={handleCheckBoxChange} handleStateEdit={handleStateEdit} />
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions
                                sx={{
                                    px: 3,
                                    py: 2,
                                    gap: 1.5,
                                    borderTop: 1,
                                    borderColor: 'divider',
                                    backgroundColor: 'grey.50',
                                    flexWrap: 'wrap',
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    onClick={handleClose}
                                    startIcon={<CloseOutlinedIcon />}
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        borderColor: '#e2e8f0',
                                        color: '#475569',
                                        '&:hover': {
                                            borderColor: '#2099d2',
                                            backgroundColor: '#2099d214',
                                            color: '#2099d2',
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    size="medium"
                                    type="submit"
                                    disabled={isSubmitting}
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        backgroundColor: '#2099d2',
                                        '&:hover': { backgroundColor: '#176990' },
                                        px: 2.5,
                                    }}
                                >
                                    Submit
                                </Button>
                            </DialogActions>





                        </Form>

                    )}
                </Formik>
            </LocalizationProvider>
        </Dialog>





    );
}

